// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1y7MD","col":"CardReaderDesc_col__A7srD","label":"CardReaderDesc_label__17-Bg"};